// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import Link from "@insite/mobius/Link";
import BrandsList, { linkListStyle } from "@mcmc/App/Components/Category/BrandsList";
import * as React from "react";
import { connect } from "react-redux";

type Props = WidgetProps & HasCategoryContext;

export interface CategoryDetailLinkListStyles {}

export const categoryDetailLinkListStyles: CategoryDetailLinkListStyles = {};

const styles = linkListStyle;

const CategoryDetailLinkList = ({ category }: Props) => {
    if (!category || !category.subCategoryIds || category.subCategoryIds.length === 0) {
        return null;
    }

    const [caterogiesAccordionOpened, setCaterogiesAccordionOpened] = React.useState(true);
    const categoryId = category.id.split(":")[0];
    return (
        <Accordion headingLevel={2}>
            <AccordionSection
                title={translate("Categories")}
                expanded={caterogiesAccordionOpened}
                onTogglePanel={() => {
                    setCaterogiesAccordionOpened(!caterogiesAccordionOpened);
                }}
                {...styles.accordionSection}
            >
                <StyledWrapper {...styles.contentWrapper}>
                    {category.subCategoryIds.map(subCategoryId => (
                        <SubCategoryLink subCategoryId={subCategoryId} key={subCategoryId.toString()} />
                    ))}
                </StyledWrapper>
            </AccordionSection>
            <BrandsList includeProductsInSubCategories={!!categoryId} categoryId={categoryId} />
        </Accordion>
    );
};

const mapStateToProps = (state: ApplicationState, ownProps: { subCategoryId: string }) => {
    return {
        category: getCategoryState(state, ownProps.subCategoryId).value,
    };
};

const SubCategoryLinkView = ({ category, key }: ReturnType<typeof mapStateToProps> & { key: string }) => {
    if (!category) {
        return null;
    }

    return (
        <Link
            key={key}
            href={category.path}
            {...styles.link}
            data-test-selector={`categoryDetailsLinkListLink_${category.id}`}
        >
            {category.shortDescription}
        </Link>
    );
};

const SubCategoryLink = connect(mapStateToProps)(SubCategoryLinkView);

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailLinkList),
    definition: {
        group: "Category Details",
        icon: "list-ul",
        allowedContexts: ["CategoryDetailsPage"],
    },
};

export default widgetModule;
